import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContractPickerComponent } from '@resident-nx/web/ui';
import {
  ConsumptionWidgetBaseComponent,
  ContractStatus,
  getContracts,
  getSelectedContract,
  LoadingType,
  LoadMetersByContract,
  SelectContract,
} from '@resident-nx/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { ConsumptionDashboardCardsWebComponent } from '../consumption-dashboard-cards/consumption-dashboard-cards.component';
import { LoadingSkeletonWebComponent } from '../../atoms/loading-skeleton/loading-skeleton.component';

@Component({
  standalone: true,
  selector: 'rs-web-consumption-widget',
  templateUrl: './consumption-widget.component.html',
  styleUrls: ['./consumption-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ContractPickerComponent,
    LoadingSkeletonWebComponent,
    ConsumptionDashboardCardsWebComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class ConsumptionWidgetWebComponent extends ConsumptionWidgetBaseComponent {
  #store = inject(Store);

  #contracts = this.#store.selectSignal(getContracts);
  #selectedContract = this.#store.selectSignal(getSelectedContract);
  protected readonly contractOptions = computed(() =>
    this.#contracts().map(contract => ({
      ...contract,
      disabled: contract.status === ContractStatus.EXPIRED,
    }))
  );
  protected readonly selectedContractId = computed(() => this.#selectedContract()?.id);
  protected readonly hasSingleContract = computed(() => this.contractOptions().length === 1);
  protected readonly LoadingType = LoadingType;

  public selectContract(id: string): void {
    if (!id || id === this.selectedContractId()) {
      return;
    }
    this.#store.dispatch(SelectContract({ id }));
    this.#store.dispatch(LoadMetersByContract());
  }
}
